import { render, staticRenderFns } from "./NotificationTemplateSetup.vue?vue&type=template&id=90b4265a&scoped=true"
import script from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationTemplateSetup.vue?vue&type=script&lang=ts"
import style0 from "./NotificationTemplateSetup.vue?vue&type=style&index=0&id=90b4265a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4265a",
  null
  
)

export default component.exports